export function getFileFormat(mimeType: string = "") {
  const mimeToFormat: Record<string, string> = {
    // Text Documents
    "text/plain": "txt",
    "text/html": "html",
    "application/rtf": "rtf",
    "text/markdown": "md",

    // Word Processing Documents
    "application/msword": "doc",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      "docx",
    "application/vnd.oasis.opendocument.text": "odt",

    // Spreadsheets
    "application/vnd.ms-excel": "xls",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
    "application/vnd.oasis.opendocument.spreadsheet": "ods",

    // Presentations
    "application/vnd.ms-powerpoint": "ppt",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      "pptx",
    "application/vnd.oasis.opendocument.presentation": "odp",

    // PDFs
    "application/pdf": "pdf",

    // Compressed Files
    "application/zip": "zip",
    "application/gzip": "gz",

    // eBooks
    "application/epub+zip": "epub",

    // Others
    "text/csv": "csv",
    "application/json": "json",
    "application/xml": "xml",
  };

  return mimeToFormat[mimeType] ?? "unknown";
}
